var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-input',{attrs:{"placeholder":_vm.placeholder,"value":_vm.corporate(_vm.inputValue),"readonly":_vm.readonly,"disabled":_vm.disabled,"noneCount":","},on:{"input":(value) => {
      _vm.inputValue = _vm.removeCorporate(value);
    },"keyup":(value) => _vm.$emit('keyup', value, _vm.corporate(_vm.inputValue)),"focusout":_vm.focusout}})
}
var staticRenderFns = []

export { render, staticRenderFns }